import { createAsyncThunk } from "@reduxjs/toolkit";
import { Client } from "@helpers/helpers";
import { API_METHOD } from "@constants/constants";
import { url } from "@constants/url-constants";

export const getContentList = createAsyncThunk(
  "contents/list",
  async ({ pageCount, limit, search, id }) => {
    const response = await Client(
      API_METHOD.GET,
      url.contents +
      `?page=${pageCount}&limit=${limit}&deleted_at=1&q=${!search ? "" : search
      }&media_id=${!id ? "" : id}`
    );
    return response.data;
  }
);

export const addContent = createAsyncThunk(
  "contents/add",
  async (data, { rejectWithValue }) => {
    try {
      const response = await Client(API_METHOD.POST, url.contents, data);
      return response.data;
    } catch (error) {
      if (error) {
        return rejectWithValue(error);
      } else {
        return rejectWithValue("Something went wrong");
      }
    }
  }
);

//fetch

export const editContent = createAsyncThunk(
  "contents/edit",
  async ({ id, data }, { rejectWithValue }) => {
    try {
      const response = await Client(
        API_METHOD.PUT,
        url.contents + `/${id}`,
        data
      );
      return response.data;
    } catch (error) {
      if (error) {
        return rejectWithValue(error);
      } else {
        return rejectWithValue("Something went wrong");
      }
    }
  }
);

export const getContentCount = async () => {
  const response = await Client(API_METHOD.GET, url.contents)
  return response.data?.data?.item?.total_count;
}

export const getContent = createAsyncThunk("contents/one", async (id) => {
  const response = await Client(API_METHOD.GET, url.contents + `/${id}`);
  return response.data;
});

